export const PIPELINE = ["sent", "received", "accepted", "invoiced", "paid"];
export const SIDE_STAGES = ["declined", "expired", "refunded"];
export const ADMIN_STAGES = ["paid", "refunded"];

export const STAGE_META = {
  sent: { label: "Sent", cls: "bg-sky-100 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  received: { label: "Received", cls: "bg-indigo-100 text-indigo-700 border-indigo-200", dot: "bg-indigo-500" },
  accepted: { label: "Accepted", cls: "bg-emerald-100 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  invoiced: { label: "Invoiced", cls: "bg-amber-100 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  paid: { label: "Paid", cls: "bg-green-600 text-white border-green-600", dot: "bg-green-600" },
  declined: { label: "Declined", cls: "bg-red-100 text-red-700 border-red-200", dot: "bg-red-500" },
  expired: { label: "Expired", cls: "bg-slate-100 text-slate-500 border-slate-200", dot: "bg-slate-400" },
  refunded: { label: "Refunded", cls: "bg-rose-100 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  converted: { label: "Booked", cls: "bg-violet-100 text-violet-700 border-violet-200", dot: "bg-violet-500" },
};

export const PAYMENT_METHODS = [
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "card", label: "Card" },
  { value: "cash", label: "Cash" },
  { value: "purchase_order", label: "Purchase order" },
  { value: "funded", label: "Funded" },
  { value: "other", label: "Other" },
];

export const QUOTE_FILTERS = [
  { value: "", label: "All quotes" },
  { value: "none", label: "No quote" },
  ...PIPELINE.map((s) => ({ value: s, label: STAGE_META[s].label })),
  { value: "part_paid", label: "Part paid" },
  ...SIDE_STAGES.map((s) => ({ value: s, label: STAGE_META[s].label })),
];

export const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;
